import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeletePageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pageName: string;
  onConfirm: () => void;
}

export function DeletePageDialog({
  open,
  onOpenChange,
  pageName,
  onConfirm,
}: DeletePageDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideClose className="border">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            Delete page "{pageName}"?
          </DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 pt-2">
              <p className="text-zinc-300">
                Deleting this page will also remove all storyboards on it. You
                can undo this action with{" "}
                <strong className="text-white font-medium">Ctrl + Z</strong> or
                restore the page from{" "}
                <strong className="text-white font-medium">History</strong>.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete Page
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
